import globalStyle from './global-style';
import colors from './colors';
import borders from './borders';
import shadows from './shadows';

interface Constants {
  columns: { mobile: number; tablet: number; desktop: number };
  gridGutter: { mobile: number; tablet: number; desktop: number };
  layout: {
    general: {
      top: { mobile: string; tablet: string; desktop: string };
      sidePadding: { mobile: string; tablet: string; desktop: string };
    };
  };
}

interface Spacings {
  [key: number]: string;
}

interface ScreensWidth {
  mobileXS: number;
  mobile: number;
  iframe: number;
  tablet: number;
  desktop: number;
}

interface MaxWidths {
  desktop: string;
}

interface Media {
  mobileXS: string;
  mobile: string;
  tablet: string;
  iframe: string;
  desktop: string;
}

interface Breakpoints {
  mobileXS: number;
  mobile: number;
  tablet: number;
  iframe: number;
  desktop: number;
}

interface Theme {
  name: string;
  colors: typeof colors;
  spacings: Spacings;
  screensWidth: ScreensWidth;
  media: Media;
  breakpoints: Breakpoints;
  constants: Constants;
  borders: typeof borders;
  shadows: typeof shadows;
  maxWidths: MaxWidths;
}

const constants: Constants = {
  columns: { mobile: 4, tablet: 12, desktop: 12 },
  gridGutter: { mobile: 8, tablet: 16, desktop: 24 },
  layout: {
    general: {
      top: {
        mobile: '1rem',
        tablet: '1rem',
        desktop: '0'
      },
      sidePadding: {
        mobile: '1rem',
        tablet: '1rem',
        desktop: '0'
      }
    }
  }
};

export const spacings: Spacings = {
  0: '0px',
  1: '4px',
  2: '8px',
  3: '12px',
  4: '16px',
  5: '24px',
  6: '32px',
  7: '48px',
  8: '64px',
  9: '80px',
  10: '96px',
  11: '120px'
};

export const screensWidth: ScreensWidth = {
  mobileXS: 374,
  mobile: 580,
  iframe: 779,
  tablet: 949,
  desktop: 1442
};

export const maxWidths: MaxWidths = {
  desktop: '1560px'
};

export const media: Media = {
  mobileXS: `@media (max-width: ${screensWidth.mobileXS}px)`,
  mobile: `@media (max-width: ${screensWidth.mobile}px)`,
  tablet: `@media (max-width: ${screensWidth.tablet}px)`,
  iframe: `@media (max-width: ${screensWidth.iframe}px)`,
  desktop: `@media (max-width: ${screensWidth.desktop}px)`
};

export const breakpoints: Breakpoints = {
  mobileXS: screensWidth.mobileXS,
  mobile: screensWidth.mobile,
  tablet: screensWidth.tablet,
  iframe: screensWidth.iframe,
  desktop: screensWidth.desktop
};

const theme: Theme = {
  name: 'default', // for storybook
  colors,
  spacings,
  screensWidth,
  media,
  breakpoints,
  constants,
  borders,
  shadows,
  maxWidths
};

export { globalStyle };
export default theme;
